import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommentIconComponent } from './comment-icon/comment-icon.component';
import { SegmentsNavigationModule } from 'shared/segments-navigation/segments-navigation.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
    imports: [
        CommonModule,
        SegmentsNavigationModule,
        TooltipModule,
    ],
  declarations: [
    CommentIconComponent,
  ],
  exports: [
    CommentIconComponent,
  ]
})
export class AlertsModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: AlertsModule,
      providers: []
    };
  }
}
